export default (className = "sidebar__resize-arrow") => `
  <svg class="${className}" xmlns="http://www.w3.org/2000/svg" width="22" height="13" viewBox="0 0 22 13"><path d="M6.51.782L.4 6.89 6.51 13l1.05-1.036L3.235 7.64H21.85v-1.5H3.236L7.56 1.83z" fill="#FFF" fill-rule="nonzero"/></svg>
`
